import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { GetQuoteDetailsResponse } from 'Application/models';
import { FC } from 'react';
import SubCard from 'ui-component/cards/SubCard';

interface QuoteTravelPlanProps {
    quoteDetailsData: GetQuoteDetailsResponse;
}

const QuoteTravelPlan: FC<QuoteTravelPlanProps> = ({ quoteDetailsData }) => {
    const { plan } = quoteDetailsData;

    return (
        <SubCard title={`Travel Plan: ${plan.name}`} darkTitle={true} content={false}>
            <Grid container spacing={2} sx={{ ml: 1 }}>
                <Grid item xs={12} sx={{ mt: 3 }}>
                    <Typography variant="h5" fontSize={16}>
                        Benefits:
                    </Typography>
                </Grid>
                <Grid item>
                    <TableContainer sx={{ ml: -2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Description</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {plan.travelBenefits.map((travelBenefit) => (
                                    <TableRow key={travelBenefit.benefit.benefitId}>
                                        <TableCell>{travelBenefit.benefit.name}</TableCell>
                                        <TableCell>{travelBenefit.benefit.type?.toTitle()}</TableCell>
                                        <TableCell>{travelBenefit.description}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </SubCard>
    );
};

export default QuoteTravelPlan;
